import createIcon from '../../createIcon';

/**
 * @component @name SecurityUpdate
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAzVjIxQzUgMjIuMSA1LjkgMjMgNyAyM0gxN0MxOC4xIDIzIDE5IDIyLjEgMTkgMjFWM0MxOSAxLjkgMTguMSAxIDE3IDFIN0M1LjkgMSA1IDEuOSA1IDNaTTE3IDE4SDdWNkgxN1YxOFpNMTYgMTJIMTNWOEgxMVYxMkg4TDEyIDE2TDE2IDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SecurityUpdate = createIcon('SecurityUpdate', [
  [
    'path',
    {
      d: 'M5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1H7C5.9 1 5 1.9 5 3ZM17 18H7V6H17V18ZM16 12H13V8H11V12H8L12 16L16 12Z',
      key: '1nvpf1',
    },
  ],
]);

export default SecurityUpdate;
